import { call, put, takeLatest } from "redux-saga/effects";
import { callApiWithNoAuth, Method } from "../../api/Api";
import {
  stopLoading,
  showErrorMessage,
  startLoading,
} from "../layout/action";
import {
  APPEAL_CITATION,
  GET_CITATION_DETAIL,
  PAY_CITATION,
  APPEAL_REPLY_CITATION,
} from "./action";
import { setCitation } from "./action";
import { globalRefresh } from "../home/action";

function* watchCitationDetailFun({ payload }) {
  try {
    yield put(startLoading());
    const response = yield call(callApiWithNoAuth, {
      method: Method.GET,
      // url: `/citations/${payload.citationId}/${payload.licenseId}`,
      url: `/portal/pages/home-without-session/${payload.citationId}/${payload.licenseId}`,
    });
    yield put(setCitation(response.data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Get Citation Details" }));
    yield put(setCitation({}));
  }
}

export function* watchCitationDetail() {
  yield takeLatest(GET_CITATION_DETAIL, watchCitationDetailFun);
}

export function* whatchCitationAppeal() {
  yield takeLatest(APPEAL_CITATION, function* ({ payload }) {
    try {
      yield put(startLoading());
      const response = yield call(callApiWithNoAuth, {
        method: Method.POST,
        // url: `/citations/citation/appeal`,
        url: `/portal/pages/home-without-session/citation/appeal`,
        data: payload,
      });
      yield put(stopLoading());
      yield put(globalRefresh());
      window.location.reload();
    } catch (err) {
      yield put(stopLoading());
      yield put(
        showErrorMessage({ error: err, title: "Appeal Citation Details" })
      );
    }
  });
}

export function* whatchCitationReplyAppeal() {
  yield takeLatest(APPEAL_REPLY_CITATION, function* ({ payload }) {
    try {
      yield put(startLoading());
      const response = yield call(callApiWithNoAuth, {
        method: Method.POST,
        url: `/portal/pages/home-without-session/send-driver-reply`,
        data: payload,
      });
      yield put(stopLoading());
      yield put(globalRefresh());
      window.location.reload();
    } catch (err) {
      yield put(stopLoading());
      yield put(
        showErrorMessage({ error: err, title: "Appeal Citation Details" })
      );
    }
  });
}

export function* watchPayCitationDetail() {
  yield takeLatest(PAY_CITATION, function* ({ payload }) {
    try {
      yield put(startLoading());
      const response = yield call(callApiWithNoAuth, {
        method: Method.POST,
        url: `/portal/pages/home-without-session/citations/pay`,
        data: payload.payObj,
      });

      payload.paymentSuccess();
    } catch (err) {
      yield put(showErrorMessage({
        error: err || { data: { message: "Something went wrong, please try again later." }},
        title: "Pay citation"
      }));
    } finally {
      yield put(stopLoading());
    }
  });
}
